import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_autotest_female_funnel_check from './experiments/web_autotest_female_funnel_check'
import web_fallback_on_payment_male_us from './experiments/web_fallback_on_payment_male_us'
import web_fallback_on_payment_male_eu from './experiments/web_fallback_on_payment_male_eu'
import web_fallback_on_payment_male_row from './experiments/web_fallback_on_payment_male_row'
import web_en_countries_price_optimization from './experiments/web_en_countries_price_optimization'
import web_walking_models_from_creos from './experiments/web_walking_models_from_creos'
import web_yoga_female_scratch_card_before_the_paywall from './experiments/web_yoga_female_scratch_card_before_the_paywall'
import web_fasting_f_personalized_coupon from './experiments/web_fasting_f_personalized_coupon'
import web_data_input_screens_optimized from './experiments/web_data_input_screens_optimized'
import web_tai_chi_al_risk_free_offer from './experiments/web_tai_chi_al_risk_free_offer'
import web_tai_chi_al_paywall_plan_benefits from './experiments/web_tai_chi_al_paywall_plan_benefits'
import web_paywall_with_social_proof from './experiments/web_paywall_with_social_proof'
import web_gamification_of_fallback_offer from './experiments/web_gamification_of_fallback_offer'
import web_welcome_for_applovin_tai_chi_walking from './experiments/web_welcome_for_applovin_tai_chi_walking'
import web_tai_chi_fem_v2_social_proof from './experiments/web_tai_chi_fem_v2_social_proof'
import web_tai_chi_female_v2_moto_block from './experiments/web_tai_chi_female_v2_moto_block'
import web_tai_chi_fem_v2_gifs_exercise from './experiments/web_tai_chi_fem_v2_gifs_exercise'
import web_female_tai_chi_walking_v2_fr from './experiments/web_female_tai_chi_walking_v2_fr'
import web_feedback_with_social_proof from './experiments/web_feedback_with_social_proof'
import web_upsell_price_based_card_type from './experiments/web_upsell_price_based_card_type'
import web_upsells_on_tai_chi from './experiments/web_upsells_on_tai_chi'
import web_water_fasting_health_milestone_kit from './experiments/web_water_fasting_health_milestone_kit'
import web_water_fasting_models_from_creos from './experiments/web_water_fasting_models_from_creos'
import web_fasting_f_models_from_creos from './experiments/web_fasting_f_models_from_creos'
import web_fasting_f_green_block from './experiments/web_fasting_f_green_block'
import web_fasting_f_paywall_before_after from './experiments/web_fasting_f_paywall_before_after'
import web_female_tai_chi_walking_v2_de from './experiments/web_female_tai_chi_walking_v2_de'
import web_fasting_fem_sales_tax_exclusion_i3 from './experiments/web_fasting_fem_sales_tax_exclusion_i3'
import web_tai_chi_male_checkout_update from './experiments/web_tai_chi_male_checkout_update'
import web_revisit_last_section_female from './experiments/web_revisit_last_section_female'
import web_less_sleep_more_calories from './experiments/web_less_sleep_more_calories'
import web_refactor_result_complete from './experiments/web_refactor_result_complete'
import web_tai_chi_fem_v2_questions_counter from './experiments/web_tai_chi_fem_v2_questions_counter'
import web_tai_chi_walking_fem_v2_input_screens_before_paywall from './experiments/web_tai_chi_walking_fem_v2_input_screens_before_paywall'
import web_reprice_upsells_nonus from './experiments/web_reprice_upsells_nonus'
import web_unify_upsell_second_screen from './experiments/web_unify_upsell_second_screen'
import web_legacy_plan_picker_tai_chi_yoga_walking from './experiments/web_legacy_plan_picker_tai_chi_yoga_walking'
import web_chair_workouts_large_checkout from './experiments/web_chair_workouts_large_checkout'
import web_tai_chi_higher_prices from './experiments/web_tai_chi_higher_prices'
import web_ml_price_prediction from './experiments/web_ml_price_prediction'
import web_remove_1_week_from_plans from './experiments/web_remove_1_week_from_plans'
import web_tai_chi_yoga_male_paywall_w_dynamic_line from './experiments/web_tai_chi_yoga_male_paywall_w_dynamic_line'
import web_tai_chi_yoga_male_scratch_card from './experiments/web_tai_chi_yoga_male_scratch_card'
import web_fasting_fem_ai_coach_meal_plan from './experiments/web_fasting_fem_ai_coach_meal_plan'
import web_pix_payment_method_for_br from './experiments/web_pix_payment_method_for_br'
import web_pricing_au_dk_se_ch from './experiments/web_pricing_au_dk_se_ch'
import web_input_screens_before_paywall from './experiments/web_input_screens_before_paywall'
import web_fasting_f_improve_copy from './experiments/web_fasting_f_improve_copy'
import web_f_tai_chi_walking_v2_al_bmi_post_funnel from './experiments/web_f_tai_chi_walking_v2_al_bmi_post_funnel'
import web_upsell_pace_segments from './experiments/web_upsell_pace_segments'
import web_f_tai_chi_walking_price_before_scratch from './experiments/web_f_tai_chi_walking_price_before_scratch'
import web_tai_chi_walking_v2_lee_as_a_model from './experiments/web_tai_chi_walking_v2_lee_as_a_model'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	// fasting
	female: {
		web_gamification_of_fallback_offer,
		web_autotest_female_funnel_check,
		web_fasting_f_personalized_coupon,
		web_data_input_screens_optimized,
		web_feedback_with_social_proof,
		web_fasting_fem_sales_tax_exclusion_i3,
		web_revisit_last_section_female,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_fasting_f_models_from_creos,
		web_fasting_f_green_block,
		web_fasting_fem_ai_coach_meal_plan,
		web_fasting_f_paywall_before_after,
		web_fasting_f_improve_copy,
		web_unify_upsell_second_screen,
		web_input_screens_before_paywall,
		web_upsell_pace_segments,
	},
	male: {
		web_en_countries_price_optimization,
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_unify_upsell_second_screen,
		web_ml_price_prediction,
	},
	main: {},

	// yoga
	'activity-female-yoga': {
		web_yoga_female_scratch_card_before_the_paywall,
		web_legacy_plan_picker_tai_chi_yoga_walking,
	},
	'activity-male-chair-workouts': {
		web_paywall_with_social_proof,
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_chair_workouts_large_checkout,
		web_ml_price_prediction,
	},
	'main-yoga': {},

	// walking
	'activity-female-walking': {
		web_en_countries_price_optimization,
		web_upsell_price_based_card_type,
		web_upsells_on_tai_chi,
		web_legacy_plan_picker_tai_chi_yoga_walking,
		web_remove_1_week_from_plans,
		web_unify_upsell_second_screen,
		web_f_tai_chi_walking_price_before_scratch,
	},
	'activity-male-walking': {
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_upsell_price_based_card_type,
		web_upsells_on_tai_chi,
		web_unify_upsell_second_screen,
		web_ml_price_prediction,
	},
	'activity-female-nordic-walking-fwf': {},
	'female-printable-walking': {},
	'main-walking': {
		web_walking_models_from_creos,
	},

	// pilates
	'activity-female-pilates': {},
	'activity-female-boudoir-pilates-fwf': {},

	// activity
	'activity-female-v2': {},
	'activity-male': {},
	'main-activity': {},

	// tai-chi
	'activity-female-tai-chi': {},
	'activity-female-tai-chi-walking': {},
	'activity-female-tai-chi-walking-v2': {
		web_gamification_of_fallback_offer,
		web_tai_chi_fem_v2_social_proof,
		web_tai_chi_female_v2_moto_block,
		web_tai_chi_fem_v2_gifs_exercise,
		web_female_tai_chi_walking_v2_fr,
		web_upsell_price_based_card_type,
		web_female_tai_chi_walking_v2_de,
		web_upsells_on_tai_chi,
		web_less_sleep_more_calories,
		web_tai_chi_fem_v2_questions_counter,
		web_tai_chi_walking_fem_v2_input_screens_before_paywall,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_legacy_plan_picker_tai_chi_yoga_walking,
		web_tai_chi_higher_prices,
		web_remove_1_week_from_plans,
		web_unify_upsell_second_screen,
		web_pix_payment_method_for_br,
		web_upsell_pace_segments,
		web_f_tai_chi_walking_price_before_scratch,
		web_ml_price_prediction,
		web_tai_chi_walking_v2_lee_as_a_model,
	},
	'activity-female-tai-chi-walking-pr': {
		web_upsells_on_tai_chi,
		web_refactor_result_complete,
		web_tai_chi_higher_prices,
		web_remove_1_week_from_plans,
		web_unify_upsell_second_screen,
		web_pix_payment_method_for_br,
		web_upsell_pace_segments,
		web_f_tai_chi_walking_price_before_scratch,
		web_ml_price_prediction,
	},
	'activity-male-tai-chi-walking': {},
	'activity-male-tai-chi-yoga': {
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_male_paywall_w_dynamic_line,
		web_tai_chi_yoga_male_scratch_card,
		web_upsells_on_tai_chi,
	},
	'activity-male-tai-chi-yoga-pr': {
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_male_paywall_w_dynamic_line,
		web_tai_chi_yoga_male_scratch_card,
		web_pix_payment_method_for_br,
		web_ml_price_prediction,
		web_upsells_on_tai_chi,
		web_unify_upsell_second_screen,
	},
	'activity-female-chair-tai-chi-fwf': {},
	'activity-male-chair-tai-chi': {},
	'tai-chi-male-golfers-fwf': {},
	'main-tai-chi': {},
	'main-tai-chi-pr': {},
	'main-tai-chi-walking': {
		web_tai_chi_fem_v2_social_proof,
	},
	'main-tai-chi-walking-pr': {},

	// glp
	'female-glp': {},
	'glp-1': {},

	// calisthenics

	// japanese-walking
	'activity-female-walking-japanese': {},
	'activity-female-walking-japanese-v2': {},

	// asian-pilates

	// military

	// water-fasting
	'female-water-fasting': {
		web_water_fasting_health_milestone_kit,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_water_fasting_models_from_creos,
		web_unify_upsell_second_screen,
	},
	'male-water-fasting': {},

	// ayurveda fwf
	'female-ayurveda-fwf': {},

	// high-protein

	// diets
	'female-cortisol-diet': {},
	'female-menopause-diet': {},
	'female-mediterranean-diet': {},
	'female-anti-inflammatory-diet': {},
	'female-ramadan-fwf': {},

	// applovin
	'activity-male-chair-workouts-al': {},
	'activity-female-yoga-al': {},
	'activity-female-walking-al': {},
	'activity-male-tai-chi-yoga-al': {},
	'activity-male-tai-chi-walking-al': {},
	'female-al': {},
	'female-water-fasting-al': {},
	'activity-female-tai-chi-walking-al': {},
	'activity-female-tai-chi-walking-v2-al': {
		web_tai_chi_al_risk_free_offer,
		web_tai_chi_al_paywall_plan_benefits,
		web_welcome_for_applovin_tai_chi_walking,
		web_upsells_on_tai_chi,
		web_refactor_result_complete,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_tai_chi_higher_prices,
		web_remove_1_week_from_plans,
		web_unify_upsell_second_screen,
		web_pix_payment_method_for_br,
		web_f_tai_chi_walking_v2_al_bmi_post_funnel,
		web_upsell_pace_segments,
		web_f_tai_chi_walking_price_before_scratch,
	},

	// other
}

export default experimentsConfig
